import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchServices } from '@/api/services/servicesApi';
import type { Service } from '@/api/services/servicesApi.types';
import { SERVICES_QUERY_KEY } from '@/constants/queryKeys';

export function useServicesQuery(
  search: string,
  includeInactive: boolean,
  isEnabled: boolean
): UseQueryResult<Service[], Error> {
  return useQuery({
    queryKey: [...SERVICES_QUERY_KEY, search, includeInactive],
    queryFn: function loadServices() {
      return fetchServices(search, includeInactive);
    },
    enabled: isEnabled,
  });
}
